import { useTranslation } from "@/hooks";
import { formatNumber } from "@/utils/tools";
import { Skeleton, Typography } from "@st-marketplace/ui";

type Props = {
	actualStock: number;
	ratio: number | null;
	loading?: boolean;
};

const SettingsStockVisibility: React.FC<Props> = ({
	actualStock,
	ratio,
	loading = false,
}) => {
	const { t } = useTranslation();

	const visibleStock = Math.round(actualStock * ((ratio ?? 0) / 100));

	const row = (label: string, value: number) => (
		<div className="flex items-center justify-between gap-4">
			<Typography variant="body-sm" className="text-secondary-text-100">
				{label}
			</Typography>
			{loading ? (
				<Skeleton className="h-4 w-20" />
			) : (
				<Typography variant="body-sm" className="tabular-nums">
					{formatNumber(value, "count")}
				</Typography>
			)}
		</div>
	);

	return (
		<div className="flex flex-col gap-1">
			{row(t("settings.marketplace.actualStockValue"), actualStock)}
			{row(t("settings.marketplace.buyersSeeStockValue"), visibleStock)}
			<Typography variant="body-sm" className="text-warning-text">
				{t("settings.marketplace.stockVisibilityHelpText")}
			</Typography>
		</div>
	);
};

export default SettingsStockVisibility;
